import { AxiosHeaders } from 'axios';

const extractFilenameFromHeader = (headers: AxiosHeaders): string => {
  if (headers['content-disposition']) {
    const contentDisposition = headers['content-disposition'];

    if (contentDisposition) {
      const star = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
      if (star?.[1]) return decodeURIComponent(star[1]);
      const plain = /filename="?([^"]+)"?/i.exec(contentDisposition);

      if (plain?.[1]) {
        return plain?.[1];
      }
    }
  }

  return 'report.csv';
};

const triggerDownload = (filename: string, data: BlobPart, mime: string) => {
  const blob = data instanceof Blob ? data : new Blob([data], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export { extractFilenameFromHeader, triggerDownload };
